import { Stack, Typography } from "@mui/material";
import Label from "../../../components/minimal/label/index.jsx";
import Iconify from "../../../components/minimal/iconify/index.jsx";
import useResponsive from "../../../hooks/minimal/useResponsive.jsx";
import { useDashboardContext } from "../../../context-state/DashboardContext.jsx";
import { Alert, AlertTitle } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { i18n } from "../../../locales";
import { PATH_DASHBOARD } from "../../../routes/paths";
import { Button } from "@mui/material";
import { useEffect } from "react";


const createNoTicketsWarning = ({ isSeatsEvent, subId, eventId, navigate, setDashboardOverrideMsg }) => ({
    title: i18n.t('warnings.attention'),
    msg: i18n.t('warnings.no_tickets_defined'),
    btn: (
        <Button
            color="warning"
            onClick={() => {
                const destination = isSeatsEvent
                    ? PATH_DASHBOARD.sub.event.view.seatsChart(subId, eventId)
                    : PATH_DASHBOARD.sub.event.view.tickets(subId, eventId);
                navigate(destination);
                setDashboardOverrideMsg({});
            }}
        >
            {i18n.t('warnings.define_tickets')}
        </Button>
    ),
});

export const OverrideMsg = () => {

    const isMobile = useResponsive('down', 'sm');
    const { overrideMsgContext, ticketContext, eventContext } = useDashboardContext()
    const { dashboardOverrideMsg } = overrideMsgContext
    const { getTicketsOfEvent } = ticketContext
    const { setDashboardOverrideMsg } = overrideMsgContext
    const location = useLocation()
    const { eventId, subId } = useParams()
    const navigate = useNavigate()
    const { getEvent } = eventContext
    const event = getEvent(eventId)
    const ticketsOfEvent = getTicketsOfEvent(eventId)

    const lookForEventWarnings = (event) => {
        if (event) {
            const { isSeatsEvent } = event
            if (!ticketsOfEvent || !ticketsOfEvent?.length) {
                return createNoTicketsWarning({
                    isSeatsEvent,
                    subId,
                    eventId,
                    navigate,
                    setDashboardOverrideMsg
                })
            } else if (dashboardOverrideMsg && dashboardOverrideMsg.msg) {
                // only if there is an override msg we want to remove it
                return {}
            }
        }
        return {}
    }

    useEffect(() => {
        if(!event?._id || !ticketsOfEvent) return

        let msg = {}
        if (location.pathname.includes('/event')) {
            msg = lookForEventWarnings(event)
        }
        setDashboardOverrideMsg(msg)
    }, [location.pathname, event?._id, ticketsOfEvent?.length])

    if (!dashboardOverrideMsg?.msg) {
        return null
    }

    return (
        <Stack sx={{ zIndex: 99999, position: "fixed", justifyContent: "center", width:  '100%' }}>
            <Alert sx={{
                margin: 2, display: 'flex', justifyContent: 'center', alignItems: 'center',
                "& > *": {
                    flexGrow: 0, // Ensures children do not grow
                },
            }} severity={dashboardOverrideMsg.severity || 'warning'} action={dashboardOverrideMsg.btn}>
                <AlertTitle>{dashboardOverrideMsg.title}</AlertTitle>
                {dashboardOverrideMsg.msg}
            </Alert>
        </Stack>
        //    <Stack sx={{ textAlign: 'center', zIndex: 99999, position: "fixed", justifyContent: "center", width: '100%' }} direction="row">
        //        <Label variant="filled" color="error" sx={{ display: "flex", gap: 1, alignItems: 'center', p: 2, borderRadius: isMobile ? 0 : 1, minWidth: isMobile ? "100%" : "unset" }}>
        //            <Iconify icon="eva:alert-circle-outline" />
        //            <Typography variant="body2">
        //                {dashboardOverrideMsg.msg}
        //            </Typography>
        //        </Label>
        //    </Stack>
    )
}
